var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(-1731 -178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(1731 178)",
    fill: "none",
    stroke: "#fe7b43",
    strokeWidth: 2,
    strokeDasharray: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Add_Icon",
    "data-name": "Add Icon",
    d: "M20.218,14.218H15.712V9.712a.747.747,0,0,0-1.494,0v4.506H9.712a.747.747,0,0,0,0,1.494h4.506v4.506a.747.747,0,1,0,1.494,0V15.712h4.506a.747.747,0,1,0,0-1.494Z",
    transform: "translate(1728.035 175.035)",
    fill: "#fe7b43"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOrange);
export default __webpack_public_path__ + "static/media/addOrange.dc2ee762a953283972e1e1af0be75ce0.svg";
export { ForwardRef as ReactComponent };